import { styled } from "baseui";

export const Card = styled("div", () => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  padding: "24px",
  borderRadius: "16px",
  backgroundColor: "#484e54",
  border: "1px solid rgba(90, 97, 105, 0.2)",
}));

export const TopInfo = styled("div", () => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "20px",
}));

export const TitleWrapper = styled("div", () => ({
  width: "calc(100% - 60px)",
  display: "flex",
  flexDirection: "column",
}));

export const Title = styled("span", ({ $theme }) => ({
  ...$theme.typography.fontBold16,
  fontFamily: "'Lato', sans-serif",
  lineHeight: "1.3",
  color: "#cfd1d7",
  marginBottom: "8px",
  fontSize: "16px",
  fontWeight: 700,
}));

export const Text2 = styled("span", ({ $theme }) => ({
  ...$theme.typography.fontBold14,
  fontFamily: "'Lato', sans-serif",
  lineHeight: "1.3",
  color: "#cfd1d7",
  marginBottom: "6px",
  fontSize: "14px",
  fontWeight: 600,
}));

export const SubTitle = styled("span", ({ $theme }) => ({
  ...$theme.typography.fontBold13,
  fontFamily: "'Lato', sans-serif",
  lineHeight: "1.3",
  color: "#8e94a0",
  marginBottom: "0px",
  fontSize: "13px",
}));

export const IconBox = styled("div", () => ({
  width: "48px",
  height: "48px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const Price = styled("span", ({ $theme }) => ({
  ...$theme.typography.fontBold21,
  fontFamily: "'Lato', sans-serif",
  lineHeight: "1.2",
  color: "#cfd1d7",
  marginBottom: "10px",
}));

export const Text = styled("span", ({ $theme }) => ({
  ...$theme.typography.fontBold14,
  fontFamily: "'Lato', sans-serif",
  lineHeight: "1.2",
  marginBottom: "50px",
}));

export const Note = styled("span", ({ $theme }) => ({
  ...$theme.typography.font14,
  fontFamily: "'Lato', sans-serif",
  color: "#8e94a0",
  lineHeight: "1.4",
}));

export const Link = styled("a", ({ $theme }) => ({
  ...$theme.typography.fontBold13,
  fontFamily: "'Lato', sans-serif",
  color: "#00C58D",
  lineHeight: "1.2",
  textDecoration: "none",
  ':hover': {
    color: "#00bd87",
  },
}));
